import { Component } from "@angular/core";

@Component({
    selector: 'app-spinner-base',
    template: `
        <mat-dialog-content>
            <div class="hoa-dialog__container">
                <div class="hoa-dialog__header">
                    <h1>Network Connection Error</h1>
                </div>
                <div class="hoa-dialog__main">
                    <div class="HOA-flex-component HOA-flex-component-center-spinner u-pB4">
                        <div class="Loader Loader--lg Loader--blue"></div>
                    </div>
                    <h1 class="u-textCenter u-pB4">Reconnecting...</h1>
                    <p class="u-textCenter"> There is no internet connection. This application cannot function without
                        internet connectivity and will continue to try and reconnect until internet is
                        reestablished.</p>
                </div>
                <!--<div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer&#45;&#45;overflowX">-->
                <!--<button class="Button Button&#45;&#45;blue Button&#45;&#45;minWidth130" ng-click="closeThisDialog('Retry')">Close</button>-->
                <!--</div>-->
            </div>
        </mat-dialog-content>
    `,
})
export class SpinnerReconnectComponent {
}
